import React, { Component } from "react";
import InputForm from "../../components/InputForm";
import LabelForm from "../../components/LabelForm";
import { biometricsDataByOfferCells, biometricsOption } from "../../libs/services";

class VitalSignsData extends Component{
    constructor(props){
        super(props);

        this.getVitalSigns = this.getVitalSigns.bind(this);
        this.getVitalSignsData = this.getVitalSignsData.bind(this);
        this.calculateValuesSV = this.calculateValuesSV.bind(this);

        this.state = {
            vital_signs:[],
            sample_valid:false,
        }
    }

    componentDidMount(){
        this.props.onRef(this);
    }

    componentWillUnmount(){
        this.props.onRef(null);
    }

    async getVitalSigns(sex){
        var id = this.props.match.params.id === undefined ? this.props.variables.id : this.props.match.params.id;
        var type = this.props.match.params.type === undefined ? this.props.variables.type : this.props.match.params.type;   

        var response = await biometricsOption('BIO_F_SIGNOS', sex);
		if(response !== undefined){
            response.forEach((res)=>{
                res.value = '';
                res.borderColor = '#ccc';
                res.class = '';
                res.maxLength = 4;

                if(type === 'CELLS'){
                    res.offering_cell_id = id;
                }
            });
            
			await this.setState({vital_signs: response});
			await this.getVitalSignsData();
			
		}
    }

    async getVitalSignsData(){
        var id = this.props.match.params.id === undefined ? this.props.variables.id : this.props.match.params.id;
        var type = 'BIO_F_SIGNOS';

		var response = await biometricsDataByOfferCells(id, type);

		if(response !== undefined){
			var vital_signs = this.state.vital_signs;
            vital_signs.forEach((item, i)=>{
                var index = response.values.findIndex(obj => obj.biometrics_id === item.id);
                
                if(index !== -1){
                    var obj = {
                        target:{
                            id:item.id,
                            value:response.values[index].value
                        }
                    };
                    
                    this.calculateValuesSV(obj);                    
                }
            });

            this.setState({sample_valid: response.sample_valid});

            if(this.props.handleChange !== undefined){
                this.props.handleChange({target:{name:'incident_id', value:response.incident_id}});
            }
            
		}
    }

    async calculateValuesSV(e){
        var id = parseInt(e.target.id);
        var value = e.target.value;

        var vital_signs = this.state.vital_signs;

        var index = vital_signs.findIndex(item => item.id === id);
        
        if(index !== -1){
            vital_signs[index].value = value;
            
            if(value !== '' && value !== null){
                if(value.toString().indexOf('.') !== -1){
                    vital_signs[index].maxLength = 5;
                }else{
                    vital_signs[index].maxLength = 4;
                }
            }
            
        }

        await this.setState({vital_signs:vital_signs});

        await this.validateRangeSV(id, value);    

        vital_signs.forEach((field)=>{
            if(field.data_type === 'BIO_D_CALCULATED'){
                var str = field.formula.split('&');                
                var val = this.getTerms(str, value);
                
                if(value !== '' && value !== null){
                    if(value.toString().indexOf('.') !== -1){
                        field.maxLength = 5;
                    }else{
                        field.maxLength = 4;
                    }
                }            

                if(val !== ''){
                    if(field.required && field.class === 'error'){
                        field.class = '';
                    }
                    
                    field.value = val;
                    field.class = '';
                }else{
                    field.value = '';
                    field.class = 'error';
                }    
            }
        })        

        
        await this.setState({vital_signs:vital_signs});
        
    }

    validateRangeSV(id, value){
        var vital_signs = this.state.vital_signs;
        
        var index = vital_signs.findIndex(item => item.id === id);
        if(index !== -1){
            if(vital_signs[index].ranges_validation){
                var val = parseFloat(value);
                if(this.props.sex === "HOMBRE"){
                    if(val >= vital_signs[index].low_rank_male && val <= vital_signs[index].high_rank_male){
                        vital_signs[index].borderColor = "#ccc";
                    }else{
                        vital_signs[index].borderColor = "red";
                    }
                }else{
                    if(val >= vital_signs[index].low_rank_female && val <= vital_signs[index].high_rank_female){
                        vital_signs[index].borderColor = "#ccc";
                    }else{
                        vital_signs[index].borderColor = "red";
                    }
                }
            }
        }

        this.setState({vital_signs:vital_signs});
    }

 getTerms(term, value){
        // console.log("TERM",term)  
		var result = "";
		var formula = "";

        term.forEach((t)=>{
           // console.log("T",t)
            var id = parseFloat(t);
           
            if(!isNaN(id)){
                
                var index  = this.state.vital_signs.findIndex(item => item.id === id);     
                       
                if(index !== -1){
                    var value = this.state.vital_signs[index].value.toString();
                    if(id == 22){
                        
                        if(value.includes(".")){
                            formula = formula + (this.state.vital_signs[index].value)
                            console.log("CON PUNTO",(this.state.vital_signs[index].value))
                        }
                       else{
                        formula = formula + (this.state.vital_signs[index].value)/100
                        console.log("SIN PUNTO",(this.state.vital_signs[index].value))
                       }
                    }
                    else{
                        formula = formula + (this.state.vital_signs[index].value)
                    }
                    
                    
                }
                
            }else{
                formula = formula + t;
            }
        });		

		try{
			result =   eval(formula);
		}catch(e){
			return "";
		}

		if (!isNaN(result)) {
			return (result).toFixed(2);
		} else{
			return "";
		};
	}

    render(){
        return(
            <fieldset>
                {!this.props.vertical && <legend>Signos Vitales</legend>}
                <div className={this.props.container}>
                    {this.state.vital_signs.map((vs, i)=>
                        <div className={this.props.vertical ? "col-xs-12" : "col-xs-12"} key={i}>
                            <LabelForm text={vs.name} />
                            <InputForm 
                                id={vs.id}
                                value={vs.value}
                                required={vs.required}
                                handleChange={this.calculateValuesSV}
                                maxLength={vs.maxLength}
                                type="number"
                                disabled={vs.data_type === "BIO_D_CALCULATED" || (!this.props.task_vital_signs.create && !this.props.task_vital_signs.update)||this.props.exist_extraction} 
                            />
                        </div>
                    )}
                </div>
                
            </fieldset>
        )
    }
}

export default VitalSignsData;

VitalSignsData.defaultProps = {
    container:'biometrics-container',
    vertical:false
}